import {useMediaQuery,useTheme} from "@mui/material";
import { HomeDesktopView } from "./HomeDesktopView/HomeDesktopView";
import { HomeMobileView } from "./HomeMobileView/HomeMobileView";

export function Home() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
      <>
          {!isMobile && <HomeDesktopView/>}
          {isMobile && <HomeMobileView />}
      </>
  );
}

